import { useContext } from 'react'
import { FieldValues, useFormContext } from 'react-hook-form'

import { SetupPrebidStackSectionContext } from 'features/globalSetup/contexts/SetupPrebidStackSectionContext'
import { useAbility } from 'providers/casl'
import { CommonProps } from '../../types'
import { UseCheckDisabledState } from './types'

export const useAccessibility = <Schema extends FieldValues>({
  gamSetupOrder,
}: Pick<CommonProps, 'gamSetupOrder'>): UseCheckDisabledState => {
  const ability = useAbility()
  const {
    formState: { isValid },
  } = useFormContext<Schema>()
  const { available } = useContext(SetupPrebidStackSectionContext)

  const isActionDisabled =
    !available ||
    ability.cannot('update', 'GlobalSetupFeature-googleAdManagerConnection-setupPrebidStack')

  const isSaveButtonDisabled = !available || !isValid

  const isSaveButtonVisible =
    gamSetupOrder?.status !== 'inProgress' &&
    ability.can('update', 'GlobalSetupFeature-googleAdManagerConnection-setupPrebidStack')

  return { isActionDisabled, isSaveButtonDisabled, isSaveButtonVisible }
}
